import {FC, RefObject, useState} from 'react';
import {Box, Center, Stack} from '@chakra-ui/react';
import {api, useT} from '@kcast-fe/core';
import {Loader, SearchInputBig, useScreenSize} from 'ui-kit';

import {ReminderItem} from './components';

interface IProps {
  ref: RefObject<HTMLDivElement | null>;
}

const RemindersFC: FC<IProps> = ({ref}) => {
  const {data: reminders = [], isLoading} = api.memoryReminders.useRemindersQuery();
  const {data: settings} = api.settings.useSettingsQuery();

  const [query, setQuery] = useState('');

  const {t} = useT();
  const {isLessThan768} = useScreenSize();

  const filteredReminders = query
    ? reminders.filter((r) => r.prompt.toLowerCase().includes(query.toLowerCase()))
    : reminders;

  return (
    <Box ref={ref} h={'calc(100% - 4px)'} overflow={'hidden'}>
      <Stack h={'100%'} gap={'0'}>
        {reminders.length > 0 && (
          <Box p={isLessThan768 ? '12px 8px 0 8px' : '12px 24px 6px'}>
            <SearchInputBig value={query} onChange={setQuery} />
          </Box>
        )}

        <Box flex={'1 1 auto'} overflowY={'auto'} p={isLessThan768 ? '0 12px' : '0 24px'}>
          {isLoading && (
            <Center h={'100%'}>
              <Loader size={'lg'} />
            </Center>
          )}

          {!isLoading && reminders.length === 0 && (
            <Center
              flexDirection={'column'}
              gap={'24px'}
              h={'100%'}
              textAlign={'center'}
              p={'0 24px'}
            >
              <Box fontWeight={'500'} color={'{colors.textPrimary}'}>
                {t('reminders.list.empty')}
              </Box>
              <Box color={'{colors.textSecondary}'} maxW={'400px'}>
                {t('reminders.list.emptyDescription', {name: settings?.assistant?.name})}
              </Box>
            </Center>
          )}

          {!isLoading && (
            <Box>
              {filteredReminders.map((reminder) => (
                <ReminderItem key={reminder.id} reminder={reminder} containerRef={ref} />
              ))}
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export const Reminders = RemindersFC;
